import React, { Component } from "react";
import "animate.css/animate.min.css";
import ScrollAnimation from 'react-animate-on-scroll';
import OwlCarousel from "react-owl-carousel3";
import config from './data/Services';

const options = {
  loop: true,
  nav: true,
  dots: true,
  autoplayHoverPause: true,
  autoplay: true,
  navText: [
    "<i class='fas fa-angle-left'></i>",
    "<i class='fas fa-angle-right'></i>",
  ],
  responsive: {
    0: {
      items: 1,
    },
    768: {
      items: 2,
    },
    1200: {
      items: 3,
    },
  },
};

class Services extends Component {
  state = { display: false };

  componentDidMount() {
    this.setState({ display: true });
  }
  render() {
    return (
      <section id="services" class="services-section-6">
        <div class="event-schedule-area-two bg-color pad100">
          <div class="container">
            <div class="row mb-5">
              <div class="title col-md-8 col-xl-6 text-center mx-auto">
                <ScrollAnimation animateIn="animate__fadeIn" animateOnce={true} delay={100}>
                  <h2 class="font-weight-bold mb-4">{config.title}</h2>
                </ScrollAnimation>
              </div>
            </div>
            <div className="row">
              {this.state.display ? (
                <OwlCarousel
                  className="owl-carousel owl-theme"
                  {...options}
                >
                  {config.services.map((item, index) => {
                    return (
                      <div key={index} class="col-md-12 col-lg-12">
                        <ScrollAnimation animateIn="animate__fadeIn" animateOnce={true} delay={item.delay}>
                          <div class="rounded">
                            <img class="img-fluid" src={require("../../assets/image/img-600x400-1.jpg")} />
                            <div class="position-relative p-4 pt-0">
                              <h4 class="mb-3">{item.title}</h4>
                              <p>{item.description}</p>
                            </div>
                          </div>
                        </ScrollAnimation>
                      </div>
                    );
                  })}
                </OwlCarousel>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Services;